<template>
  <div class="one-key-access">
    <div class="title">能力丰富，一键接入</div>
    <div class="body">
      <div class="body-tab">
        <div v-for="(item, index) in oneKeyAccessList" :key="index" :class="item.active" @click="changeTab(index)">
          <span>{{item.text}}</span>
        </div>
      </div>
      <div class="body-div">
        <div v-if="changeIndex == '0'" class="body-div-content">
          <div class="body-div-content-first item0">
            <div class="img1">
              <img src="../image/title_digital.svg">
            </div>
            <div class="img2">
              <img src="../image/logo_digtal.svg">
            </div>
          </div>
          <div v-for="(item, index) in DigitalGuangDongList" :key="index" class="body-div-content-item"
               :class="index < 3 ? 'row1' : ''" @click="linkTo(item)">
            <img :src="item.imgSrc" class="img">
            <div class="title">{{item.title}}</div>
            <div class="detail">{{item.detail}}</div>
          </div>
          <!--<div class="body-div-content-last body-div-content-item" @click="showOr()">-->
          <!--<div class="show" v-if="show">-->
          <!--展开全部-->
          <!--</div>-->
          <!--<div class="show" v-if="!show">-->
          <!--收起全部-->
          <!--</div>-->
          <!--<img src="../image/more.png" v-if="show">-->
          <!--<img src="../image/collapse.png" v-if="!show">-->
          <!--</div>-->
        </div>
        <div v-if="changeIndex == '1'" class="body-div-content">
          <div class="body-div-content-first item1">
            <div class="img1">
              <img src="../image/title_tencentcloud.svg">
            </div>
            <div class="img2">
              <img src="../image/logo_tencentcloud.svg">
            </div>
          </div>
          <div v-for="(item, index) in TencentCloudList" :key="index" class="body-div-content-item"
               :class="index < 3 ? 'row1' : ''" @click="linkTo(item)">
            <img :src="item.imgSrc" class="img">
            <div class="title">{{item.title}}</div>
            <div class="detail">{{item.detail}}</div>
          </div>
        </div>
        <div v-if="changeIndex == '2'" class="body-div-content">
          <div class="body-div-content-first body-div-content-item item2">
            <div class="img1">
              <img src="../image/title_wechat.svg">
            </div>
            <div class="img2">
              <img src="../image/logo_wechat.svg">
            </div>
          </div>
          <div v-for="(item, index) in WeChatList" :key="index" class="body-div-content-item it"
               :class="index < 3 ? 'row1' : ''" @click="linkTo(item)">
            <img :src="item.imgSrc" class="img">
            <div class="title">{{item.title}}</div>
            <div class="detail">{{item.detail}}</div>
          </div>
        </div>
        <div v-if="changeIndex == '3'" class="body-div-content">
          <div class="body-div-content-first item3">
            <div class="img1">
              <img src="../image/title_WechatWork.svg">
            </div>
            <div class="img2">
              <img src="../image/logo_WechatWork.svg">
            </div>
          </div>
          <div v-for="(item, index) in WeChatWorkList" :key="index" class="body-div-content-item"
               :class="index < 3 ? 'row1' : ''" @click="linkTo(item)">
            <img :src="item.imgSrc" class="img">
            <div class="title">{{item.title}}</div>
            <div class="detail">{{item.detail}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '@_src/common/core/config';

  export default {
    name: '',
    data () {
      return {
        oneKeyAccessList: [
          {
            text: '数字政府',
            active: 'active',
          },
          {
            text: '腾讯云',
            active: '',
          },
          {
            text: '微信',
            active: '',
          },
          {
            text: '政务微信',
            active: '',
          },
        ],
        DigitalGuangDongList: [
          {
            imgSrc: require('../image/el-ic-net.svg'),
            title: 'API网关',
            detail: '为企业合作伙伴和服务开发者提供数据和服务，建设统一的、规范化、安全的总线服务',
            url: `${config.host}ability/1`,
          },
          {
            imgSrc: require('../image/el-ic-box.svg'),
            title: '准入网关',
            detail: '为互联网、政务外网、公安网等民生服务应用提供了安全、可控、高效的身份接入、设备鉴权和按应用授权的资源准入服务',
            url: `${config.host}ability/2`,
          },
          // {
          //   imgSrc: require('../image/el-ic-frame.svg'),
          //   title: '容器服务',
          //   detail: '围绕应用和微服务的 PaaS 平台，提供服务全生命周期管理能力和数据化运营支持',
          //   url: `${config.host}ability/3`,
          //   action () {
          //     this.$toast.info('正在开发中，敬请期待');
          //   },
          // },
          {
            imgSrc: require('../image/el-ic-identity.svg'),
            title: '统一身份认证平台',
            detail: '构建统一身份认证中心，并对接国家统一身份认证系统，实现“一次登录、全网通办”',
            url: `${config.host}ability/5`,
          },
          {
            imgSrc: require('../image/el-ic-sticker.svg'),
            title: '电子签章',
            detail: '与国家政务平台统一电子印章系统(SM9算法)无缝对接，兼容传统电子印章系统',
            url: `${config.host}ability/6`,
          },
          {
            imgSrc: require('../image/el-ic-idcard.svg'),
            title: '电子证照',
            detail: '兼容国家电子证照共享交换系统并适配不同厂商的证照系统',
            url: `${config.host}ability/7`,
          },
          {
            imgSrc: require('../image/el-ic-express.svg'),
            title: '物流服务',
            detail: '通过物流平台，实现办事“不跑腿”，寄件“免填单”，收件“不着急”，办事无忧',
            url: `${config.host}ability/4`,
          },
          {
            imgSrc: require('../image/el-ic-list.svg'),
            title: '事项目录',
            detail: '统一事项目录服务，对有资格接入的政务业务系统提供提供目录清单和实施清单数据',
            url: `${config.host}ability/8`,
          },
        ],
        TencentCloudList: [
          {
            imgSrc: require('../image/el-ic-position.svg'),
            title: '腾讯位置服务',
            detail: '基于海量位置数据和人群动态数据，接入方式灵活，为城市规划和运营提供数据支撑。',
            url: `${config.host}ability/9`,
          },
          {
            imgSrc: require('../image/el-ic-photos.svg'),
            title: '智能图像',
            detail: '提供多样化的图像识别服务，满足多场景的智能识图需求 ',
            url: `${config.host}ability/18`,
          },
          {
            imgSrc: require('../image/el-ic-video.svg'),
            title: '实时音视频',
            detail: '支持多终端接入方式之间互通，快速从零开始搭建实时音视频通信平台',
            url: `${config.host}ability/11`,
          },
        ],
        WeChatList: [
          {
            imgSrc: require('../image/el-ic-face.svg'),
            title: '人脸核身',
            detail: '依托腾讯公司及微信的生物识别技术，通过人脸识别+公安比对，校验用户实名信息和本人操作',
            url: `${config.host}ability/12`,
          },
          {
            imgSrc: require('../image/el-ic-wechatpay.svg'),
            title: '微信支付实名认证',
            detail: '基于微信庞大的微信支付实名用户基础，提供微信支付实名支付账户信息授权接口',
            url: `${config.host}ability/13`,
          },
          {
            imgSrc: require('../image/el-ic-bankcard.svg'),
            title: '非税支付',
            detail: '针对非税缴费设计的支付方案和接口，建立并简化业务部门与财政、银行间非税支付的连接',
            url: `${config.host}ability/14`,
          },
        ],
        WeChatWorkList: [
          {
            imgSrc: require('../image/el-ic-identity-red.svg'),
            title: '统一登录',
            detail: '帮助组织构建独有的生态系统，连接人、内部系统和应用',
            url: `${config.host}ability/15`,
          },
          {
            imgSrc: require('../image/el-ic-contacts.svg'),
            title: '通讯录管理',
            detail: '提供强大的组织管理能力，可以自由对接组织现有人事系统、自动导入组织内成员',
            url: `${config.host}ability/16`,
          },
          {
            imgSrc: require('../image/el-ic-management.svg'),
            title: '应用管理',
            detail: '丰富的系统办公应用，轻量化应用集成和对接，支撑集成机构自身办公应用',
            url: `${config.host}ability/17`,
          },
        ],
        changeIndex: 0,
        show: true,
      };
    },
    methods: {
      changeTab (index) {
        for (let i = 0; i < this.oneKeyAccessList.length; i++) {
          this.oneKeyAccessList[i].active = false;
        }
        this.oneKeyAccessList[index].active = 'active';
        this.changeIndex = index;
      },
      showOr () {
        if (this.show) {
          let arr = [
            {
              imgSrc: require('../image/el-ic-list.svg'),
              title: '事项目录',
              detail: '统一事项目录服务，对有资格接入的政务业务系统提供提供目录清单和实施清单数据',
              url: `${config.host}ability/8`,
            },
          ];
          this.DigitalGuangDongList = this.DigitalGuangDongList.concat(arr);
        }
        else {
          this.DigitalGuangDongList.pop();
          // this.DigitalGuangDongList.pop();
        }

        this.show = !this.show;
      },
      linkTo (item) {
        // let str = this.DigitalGuangDongList[index].url;
        // console.log(str.substring(str.length - 3));
        // sessionStorage.setItem('Hash', str.substring(str.length - 3));
        if (item.action && typeof item.action === 'function') {
          item.action.apply(this);
          return false;
        }
        window.location.href = item.url;
      },
    },
  };
</script>

<style lang="less" src="../styles/one-key-access.less"></style>
